import React, { Component } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import actions from "../../redux/action";
import Survey from "./survey/Survey";
import SignUpRender from "./children/SignUpRender";
import { requestGetCaptcha, requestLogin, requestSignUp, requsetGetProfile } from "../../api/apis";
import { GASignUpPageDisplay, GASignUpFromError } from "../../ga/signUp";
import Cookies from "js-cookie";
import api_domain_config from "../../constants/common";
import "../../assets/signUp.scss";

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyVisible: false, //问卷弹窗控制显示变量
      captchaObj: {
        captchaBase64: null, //验证码图片的base64格式
        captchaId: null, //验证码 id
      },
      submitLoading: false, //提交loading状态
      loginSuccess: false, //用户登录是否成功
      linkToPersonalCenter: false, //是否跳转到个人中心
      linkToPurchase: false, //是否跳转到购买链接
    };
    this.timer = null;
  }

  componentDidMount() {
    this.handleRequsetGetCode();
    this.handleUpdateCode();
    //埋点
    GASignUpPageDisplay();
  }

  componentDidUpdate(prevProps, prevState) {
    //该监听用于：用户直接点击关闭问卷弹窗的时候，登录接口还没有返回信息，监听登录接口完成后，跳转到适当的页面
    if (!prevState.loginSuccess && this.state.loginSuccess && !this.state.surveyVisible) {
      this.handleLoginRedirect();
    }
  }

  componentWillUnmount() {
    //页面卸载时，卸载计时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   *控制用户登录完毕登录后的跳转链接
   * @param {string} authorization 登录之后的用户认证（非必填）
   */
  handleLoginRedirect = authorization => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get("redirect");
    const to = urlParams.get("to");
    if (urlParams.has("redirect")) {
      if (redirect && to === "purchase") {
        console.log("购买链接");
        this.handleNavigationToPurchase();
      } else if (redirect && !to) {
        console.log("直接重定向到上一个链接");
        window.location.replace(redirect);
      }
    } else {
      this.handleNavigationToPersonalCenter();
    }
  };

  /**
   * 跳转到当前个人中心
   */
  handleNavigationToPersonalCenter = () => {
    this.setState(
      {
        linkToPersonalCenter: true,
      },
      () =>
        this.setState({
          linkToPersonalCenter: false,
        })
    );
  };

  /**
   * 跳转到购买页面
   */
  handleNavigationToPurchase = () => {
    this.setState(
      {
        linkToPurchase: true,
      },
      () =>
        this.setState({
          linkToPurchase: false,
        })
    );
  };

  /**
   *刷新验证码图形计时器，5分钟刷新一次
   */
  handleUpdateCode = () => {
    this.timer = setInterval(() => {
      this.handleRequsetGetCode();
    }, 300000);
  };

  /**
   * 控制问卷弹窗的显示和隐藏
   * @param {*Boolean} surveyVisible false即隐藏，true即显示
   */
  handleSurveyVisible = surveyVisible => {
    this.setState({
      surveyVisible,
    });
  };

  /**
   * 请求获取验证码
   */
  handleRequsetGetCode = () => {
    requestGetCaptcha()
      .then(res => {
        if (res.code === 200) {
          const captchaObj = {
            captchaBase64: res.data.base64_captcha, //验证码图片的base64格式
            captchaId: res.data.captcha_id, //验证码 id
          };
          this.setState({
            captchaObj,
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   * 请求用户注册
   * @param {object} value form表单的提交值
   */
  handleRequestSignUp = value => {
    const { captchaObj } = this.state;

    this.setState({
      submitLoading: true,
    });

    let formData = new FormData();
    formData.append("email", value.email.replace(/(^\s*)|(\s*$)/g, ""));
    formData.append("password", value.password);
    formData.append("captcha_id", captchaObj.captchaId);
    formData.append("captcha_answer", value.verificaiton);

    requestSignUp({
      body: formData,
    })
      .then(res => {
        //注册成功
        if (res.code === 200) {
          //显示问卷弹窗
          this.handleSurveyVisible(true);
          //请求登录接口登录
          this.handleRequestLogin({ email: value.email, password: value.password });
          //存储用户已注册过标识
          localStorage.setItem("isSignin", "yes");
        } else {
          GASignUpFromError(res.message);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          submitLoading: false,
        });
      });
  };

  /**
   *请求登录
   * @param {Object} data 登录参数
   */
  handleRequestLogin = data => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    let formData = new FormData();
    formData.append("email", data.email.replace(/(^\s*)|(\s*$)/g, ""));
    formData.append("password", data.password);
    if (urlParams.has("auth")) {
      formData.append("previous_authorization", urlParams.get("auth"));
    }
    requestLogin({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          console.log("登录成功");
          // localStorage.setItem("authorization", res.data.authorization);
          Cookies.set("authorization", res.data.authorization, { expires: 30, domain: api_domain_config.DOMAIN });
          this.props.onAuthorizationChange(res.data.authorization);
          this.handleRequsetGetProfile(res.data.authorization);
          this.setState({
            loginSuccess: true,
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *请求获取用户信息
   */
  handleRequsetGetProfile = authorization => {
    requsetGetProfile({ headers: { authorization } })
      .then(res => {
        if (res.code === 200) {
          this.props.onProfileObjChange(res.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *用户直接点击关闭问卷或者问卷填写完成时，执行后面的跳转操作
   */
  handleSurveyClose = () => {
    this.handleSurveyVisible(false);
    if (this.state.loginSuccess) {
      console.log("跳转到个人页面");
      this.handleLoginRedirect(this.props.authorization);
    }
  };

  render() {
    return (
      <div className="signUp-page mb-5">
        {this.state.linkToPersonalCenter && <Navigate to="/personal-center/profile" replace={true} />}
        {this.state.linkToPurchase && <Navigate to={`/purchase${this.props.urlSearch}`} replace={true} />}
        <SignUpRender
          handleRequsetGetCode={this.handleRequsetGetCode}
          handleRequestSignUp={this.handleRequestSignUp}
          captchaObj={this.state.captchaObj}
          submitLoading={this.state.submitLoading}
          urlSearch={this.props.urlSearch}
        />
        <Survey visible={this.state.surveyVisible} handleSurveyClose={this.handleSurveyClose} />
      </div>
    );
  }
}

const mapStateToPropos = state => ({
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(SignUp);
